import React, {Component} from 'react';
import {connectHits} from "react-instantsearch-dom";
// UI
import Grid from "@material-ui/core/Grid";
import DetailedCarCardBlue from "../../DetailedCarCardBlue";
import {appStyle} from '../../../theme/appStyle';
import {withStyles} from "@material-ui/core";

class AlgoliaHitsBlue extends Component {
    render() {
        const {hits} = this.props;
        return (
            hits.map(hit => {
                    return (
                        <Grid item xs={12} sm={6} md={6} lg={4} xl={4}
                              key={hit.rom_ref}
                        >
                            <DetailedCarCardBlue data={hit}/>
                        </Grid>
                    )
                }
            )
        )
    }
}

AlgoliaHitsBlue = withStyles(appStyle)(AlgoliaHitsBlue);
AlgoliaHitsBlue = connectHits(AlgoliaHitsBlue);
export default AlgoliaHitsBlue;
